<template>
  <div class="table">
    <artmisads-table :columns="columns" row-key="id" :scroll="{ x: props.activeTab === '0' ? 1300 : props.activeTab === '2' ? 800 : 1000, y: 500 }" :data-source="props.dataList" :pagination="{
      total: props.tableTotal,
      current: props.params.page,
      pageSize: props.params.size,
      showSizeChanger: true,
      pageSizeOptions: ['10', '20', '50', '100', '200']
    }" :change="onChangePage"
    
    rowClassName="table-item">
      <template #bodyCell="{ column, text }">
        <template v-if="(props.tableNaKeys || []).indexOf(column.key) != -1">
          N/A
        </template>
        <template v-else-if="column.name === 'showCurrency'">
          {{ text ? AMAZON_CURRENCY_MAPPER[props.marketplace] : '' }}{{ text }}
        </template>
        <template v-if="column.name === 'ACOS'">
          {{ text ? (text * 100).toFixed(2).replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1') + '%' : '0' }}
        </template>
        <template v-if="column.name === 'reportDateTimestamp'">
          {{ moment(text).format('YYYY-MM-DD') }}
        </template>
      </template>
      <template #summary>
        <a-table-summary-row>
          <a-table-summary-cell>Total</a-table-summary-cell>
          <a-table-summary-cell v-if="props.activeTab === '0' || props.activeTab === '2'">
            <a-typography-text v-if="(props.tableNaKeys || []).indexOf('clicks') == -1">{{
              props.tagNumParams.totalClicks }}</a-typography-text>
            <a-typography-text v-else>N/A</a-typography-text>
          </a-table-summary-cell>
          <a-table-summary-cell v-if="props.activeTab === '0'">
            <a-typography-text>{{ props.tagNumParams.totalDetailPageViews }}</a-typography-text>
          </a-table-summary-cell>
          <a-table-summary-cell v-if="props.activeTab === '0'">
            <a-typography-text>{{ props.tagNumParams.totalAddToCart }}</a-typography-text>
          </a-table-summary-cell>
          <a-table-summary-cell v-if="props.activeTab === '0'">
            <a-typography-text>{{ props.tagNumParams.totalConversions }}</a-typography-text>
          </a-table-summary-cell>
          <a-table-summary-cell v-if="props.activeTab === '1'">
            <a-typography-text>{{ props.tagNumParams.totalQuantity }}</a-typography-text>
          </a-table-summary-cell>
          <a-table-summary-cell v-if="props.activeTab === '2'">
            <a-typography-text>{{ props.tagNumParams.totalOrders ?? props.tagNumParams.totalConversions ?? 0 }}</a-typography-text>
          </a-table-summary-cell>
          <a-table-summary-cell>
            <a-typography-text>{{ props.tagNumParams.totalSalesAmount ? AMAZON_CURRENCY_MAPPER[props.marketplace] :
              ''}}{{ props.tagNumParams.totalSalesAmount }}</a-typography-text>
          </a-table-summary-cell>
          <a-table-summary-cell v-if="props.activeTab === '0'">
            <a-typography-text>{{ props.tagNumParams.totalAcos ? (props.tagNumParams.totalAcos *
              100).toFixed(2).replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1') + '%' : 0 }}</a-typography-text>
          </a-table-summary-cell>
          <a-table-summary-cell v-if="props.activeTab === '0'">
            <a-typography-text>{{ props.tagNumParams.totalDiscountedSalesAmount ?
              AMAZON_CURRENCY_MAPPER[props.marketplace] : ''}}{{ props.tagNumParams.totalDiscountedSalesAmount
              }}</a-typography-text>
          </a-table-summary-cell>
          <a-table-summary-cell v-if="props.activeTab === '0' || props.activeTab === '1'">
            <a-typography-text>{{ props.tagNumParams.totalCommissionAndFeeAmount ?
              AMAZON_CURRENCY_MAPPER[props.marketplace] : ''}}{{ props.tagNumParams.totalCommissionAndFeeAmount
              }}</a-typography-text>
          </a-table-summary-cell>
          <a-table-summary-cell v-if="props.activeTab === '0' || props.activeTab === '2'">
            <a-typography-text
              v-if="(props.tableNaKeys || []).indexOf('bonusAmount') == -1">{{ props.tagNumParams.totalBonusAmount ?
                AMAZON_CURRENCY_MAPPER[props.marketplace] : ''}}{{ props.tagNumParams.totalBonusAmount
              }}</a-typography-text>
            <a-typography-text v-else>N/A</a-typography-text>
          </a-table-summary-cell>
          
        </a-table-summary-row>
      </template>
    </artmisads-table>
  </div>
</template>
<script setup lang="jsx">
import moment from 'moment'
import { computed } from 'vue'

import { AMAZON_CURRENCY_MAPPER } from '~/contants/common'

const props = defineProps(['dataList','activeTab', 'tableNaKeys', 'marketplace', 'tableTotal', 'params', 'setParams', 'tagNumParams'])

const onChangePage = (data, filters, sorter) => {
  const { current, pageSize } = data
  let newParams = { ...props.params }
  newParams.page = current
  newParams.size = pageSize
  if (sorter) {
    const { field, order } = sorter
    newParams.sortField = field
    newParams.sortDirection = order === 'ascend' ? 'asc' : 'desc'
  } else {
    newParams.sortField = ''
    newParams.sortDirection = ''
  }
  props.setParams(newParams)
}

const columns = computed(() => {
  if (props.activeTab === '2') {
    return [
      {
        title: 'Sales Time',
        dataIndex: 'reportDateTimestamp',
        name: 'reportDateTimestamp',
        sorter: true,
      },
      {
        title: 'Clicks',
        dataIndex: 'clicks',
        sorter: true,
      },
      {
        title: 'Orders',
        dataIndex: 'orders',
        sorter: true,
      },
      {
        title: 'Sales',
        dataIndex: 'salesAmount',
        name: 'showCurrency',
        sorter: true,
      },
      {
        title: 'Bonus',
        dataIndex: 'bonusAmount',
        name: 'showCurrency',
        sorter: true,
      },
    ]
  }
  if (props.activeTab === '1') {
    return [
      {
        title: 'Sales Time',
        dataIndex: 'reportDateTimestamp',
        name: 'reportDateTimestamp',
        sorter: true,
      },
      {
        title: 'Quantity',
        dataIndex: 'quantity',
        sorter: true,
      },
      {
        title: 'Sales',
        dataIndex: 'salesAmount',
        name: 'showCurrency',
        sorter: true,
      },
      {
        title: 'Commission',
        dataIndex: 'commissionAndFeeAmount',
        name: 'showCurrency',
        sorter: true,
      },
    ]
  }
  return [
    {
      title: 'Sales Time',
      dataIndex: 'reportDateTimestamp',
      width: 110,
      name: 'reportDateTimestamp',
      sorter: true,
    },
    {
      key: 'clicks',
      title: 'Clicks',
      dataIndex: 'clicks',
      width: 85,
      sorter: true,
    },
    {
      title: 'DPVs',
      dataIndex: 'detailPageViews',
      width: 80,
      sorter: true,
    },
    {
      title: 'Add to Cart',
      dataIndex: 'addToCart',
      width: 110,
      sorter: true,
    },
    {
      title: 'Conversions',
      dataIndex: 'conversions',
      width: 100,
      sorter: true,
    },
    {
      title: 'Sales',
      dataIndex: 'salesAmount',
      name: 'showCurrency',
      width: 100,
      sorter: true,
    },
    {
      name: 'ACOS',
      title: 'ACOS',
      dataIndex: 'acos',
      width: 100,
      sorter: true,
    },
    {
      title: 'Sales for Commission',
      dataIndex: 'discountedSalesAmount',
      name: 'showCurrency',
      width: 180,
      sorter: true,
    },
    {
      title: 'Commission',
      dataIndex: 'commissionAndFeeAmount',
      name: 'showCurrency',
      width: 100,
      sorter: true,
    },
    {
      key: 'bonusAmount',
      title: 'Bonus',
      dataIndex: 'bonusAmount',
      name: 'showCurrency',
      width: 100,
      sorter: true,
    },
  ]
})
</script>
<style lang="less" scoped>
:deep(.ant-table) {
  table {
    table-layout: fixed !important;
  }

  .inactive-commission {
    color: var(--dark-4);
  }

  .status-text {
    text-transform: capitalize;
  }

  .product-item {
    display: flex;

    img {
      width: 56px;
      height: 56px;
      margin-right: 12px;
      border-radius: 8px;
      object-fit: contain;
    }

    .text {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      justify-content: center;

      .title {
        max-width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: var(--dark-1);
        font-weight: 500;
        font-size: var(--font-size-middle);
        text-decoration: underline;
      }

      .asin {
        color: var(--dark-3);
        font-weight: 500;
        font-size: var(--font-size-min);
        letter-spacing: 0.3px;
        text-align: right;
        line-height: 16px;
        text-align: left;
        margin-top: 2px;
      }
    }
  }
}
</style>
